<template>
  <BaseModal
    :value="dialogState"
    :modal-title="
      isCreateForm ? 'Créer un nouveau statut' : 'Modifier le nom du statut'
    "
    is-unique
    @close="reset"
  >
    <template #modal>
      <v-form ref="form" @submit.prevent="submit()">
        <BaseTextField
          v-model="form.name"
          autofocus
          :placeholder="$tc('utils.name', 1) + '*'"
          :error-messages="nameErrors"
          :has-error="!!nameErrors"
          @changed="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        />
      </v-form>
    </template>

    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="reset"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton :disabled="$v.$invalid" type="primary" @click="submit">
        {{ $t("utils.validate") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import {
  postOrganizationWorkflowStatus,
  patchOrganizationWorkflowStatus,
} from "@/modules/Admin/Services/workflow.service";

export default {
  name: "WorkflowCreateAndEditStatusDialog",
  mixins: [validationMixin],
  props: {
    dialogState: {
      type: Boolean,
    },
    activeStatus: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {
        name: null,
      },
    };
  },
  computed: {
    isCreateForm() {
      return !this.activeStatus;
    },
    nameErrors() {
      if (!this.$v.form.name.$dirty) {
        return "";
      }
      if (!this.$v.form.name.required) {
        return this.$t("workflow.status.error.statusNameRequired");
      }
      if (!this.$v.form.name.maxLength) {
        return this.$t(
          "workflow.status.error.statusNameMustBeLessThan255Characters"
        );
      }
      return "";
    },
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(255),
      },
    },
  },
  watch: {
    dialogState(newVal) {
      if (newVal && this.activeStatus) {
        this.form.name = this.activeStatus.name;
      } else this.form.name = "";
    },
  },
  methods: {
    reset() {
      this.form = {
        name: null,
      };
      this.$v.$reset();
      this.$emit("close");
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.isCreateForm ? await this.create() : await this.edit();
      this.reset();
    },
    async create() {
      try {
        const payload = {
          name: this.form.name,
        };
        const res = await postOrganizationWorkflowStatus(
          this.$route.params.organizationId,
          this.$route.params.workflowId,
          payload
        );
        this.$emit("statusCreated", res.data);
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.success.statusCreatedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.error.errorCreatingStatus"
          ),
          type: "ERROR",
        });
      }
    },
    async edit() {
      try {
        const payload = {
          name: this.form.name,
        };
        const res = await patchOrganizationWorkflowStatus(
          this.$route.params.organizationId,
          this.$route.params.workflowId,
          this.activeStatus.id,
          payload
        );
        this.$emit("statusUpdated", res.data);
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.success.statusModifiedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.error.errorChangingStatus"
          ),
          type: "ERROR",
        });
      }
    },
  },
};
</script>
